
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cara-pembayaran/transfer-bank",
      function () {
        return require("private-next-pages/cara-pembayaran/transfer-bank.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cara-pembayaran/transfer-bank"])
      });
    }
  